import React, { useLayoutEffect, useRef } from "react";
import serviceStar from "../Assets/imgs/servicewhitestar.webp";
import serviceStarblue from "../Assets/imgs/serviceBlueStar.webp";
import whitearrow from "../Assets/imgs/whitearrow.webp";
import flexible from "../Assets/imgs/flexibleSolution.webp";
import flexibleDark from "../Assets/imgs/flexibleDark.webp";
import gtm from "../Assets/imgs/gtm.webp";
import gtmDark from "../Assets/imgs/gtmDark.webp";
import arrow from "../Assets/imgs/arrow.webp";
import gsap from "gsap";
import { servicesGSAP, servicesPinGSAP } from "../utils/GSAPFunctions";

const Services = () => {
  const servicesRef = useRef<HTMLDivElement | null>(null);
  const servicesPinRef = useRef<HTMLDivElement | null>(null);
  const MOBILE_BREAKPOINT = 767;
  
  useLayoutEffect(() => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      return; // Skip animations on mobile
    }

    const ctx = gsap.context(() => {
      if (servicesRef.current) {
        servicesGSAP(servicesRef);
      }
      if (servicesPinRef.current) {
        servicesPinGSAP(servicesPinRef);
      }
    }, servicesRef);

    return () => ctx.revert(); // Clean up
  }, []);
  return (
    <>
      <div className="__servicesSection" ref={servicesRef}>
        <div className="container-fluid">
          <div className="__tailorMade" id="s_sub_heading">
            <div>EXPLORE OUR TAILOR-mADE</div>
          </div>
          <div className="__servicesHeading" id="banner_mheading">
            SERVI<span>C</span>ES
          </div>
          <div className="__ServicesWraper" ref={servicesPinRef}>
            <div className="row">
              <div className="col-lg-4 col-md-12 col-12 custom__col">
                <div className="__serviceCard">
                  <span className="__absCard"></span>
                  <div className="__serviceStar services_star">
                    <div className="white_star">
                      <img src={serviceStar} alt="star" />
                    </div>
                    <div className="blue_star">
                      <img src={serviceStarblue} alt="star" />
                    </div>
                  </div>
                  <div className="serviceCardHeading">
                    <div className="scard_heading"> hIVE: COMPREHENSIVE</div>
                    <div className="scard_heading">GTM STRATEGY</div>
                  </div>
                  <div className="__Bluecricle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                  <div className="__serviceDesc">
                    Drive strategic growth with a fully integrated go-to-market
                    ecosystem. We build predictable demand engines and
                    repeatable sales motions by identifying and optimising your
                    Ideal Customer Profile (ICP), the right demand generation
                    channels, and sales tech stack.
                  </div>
                  <div className="__Bluecricle mobileblueCircle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-12 custom__col">
                <div className="__serviceCard">
                  <span className="__absCard"></span>
                  <div className="__serviceStar services_star">
                    <div className="white_star">
                      <img src={flexible} alt="star" />
                    </div>
                    <div className="blue_star">
                      <img src={flexibleDark} alt="star" />
                    </div>
                  </div>
                  <div className="serviceCardHeading">
                    <div className="scard_heading">GTM</div>
                    <div className="scard_heading">MARKETING SOLUTIONS</div>
                  </div>
                  <div className="__Bluecricle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                  <div className="__serviceDesc">
                    Choose the marketing services that best fit your needs with
                    our à la carte solutions. Whether it’s multi- channel
                    advertising, SEO optimisation, or content creation, our
                    expert team delivers high-impact strategies that align with
                    your goals and drive measurable results.
                  </div>
                  <div className="__Bluecricle mobileblueCircle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-12 custom__col">
                <div className="__serviceCard">
                  <span className="__absCard"></span>
                  <div className="__serviceStar services_star">
                    <div className="white_star">
                      <img src={gtm} alt="star" />
                    </div>
                    <div className="blue_star">
                      <img src={gtmDark} alt="star" />
                    </div>
                  </div>
                  <div className="serviceCardHeading">
                    <div className="scard_heading">GTM-TECH: SALES &</div>
                    <div className="scard_heading">MARKETING TECH ALIGN</div>
                  </div>
                  <div className="__Bluecricle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                  <div className="__serviceDesc">
                    Ensure seamless integration between your sales and marketing
                    operations with our expert tech solutions. From CRM
                    management and marketing automation to granular performance
                    insights, we streamline processes to enhance efficiency and
                    maximise ROI.
                  </div>
                  <div className="__Bluecricle mobileblueCircle">
                    <div className="b__circle"></div>
                    <img src={whitearrow} alt="arrow" />
                  </div>
                </div>
              </div>
              <div className="col-lg-12 d-desktop">
                <div id="services_dbtn">
                  <div className="__defaultBtn s__btn">
                    <span className="__leftSvg">
                      <img src={arrow} alt="arrow" />
                    </span>
                    <div className="__rightSideArrow">
                      <p> ALL SERVICES</p>
                      <span className="__rightSvg">
                        <img src={arrow} alt="arrow" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 dis-mobie">
                <div id="services_dbtn">
                  <div className="__defaultBtn s__btn">
                    <span className="__leftSvg">
                      <img src={arrow} alt="arrow" />
                    </span>
                    <div className="__rightSideArrow">
                      <p> ALL SERVICES</p>
                      <span className="__rightSvg">
                        <img src={arrow} alt="arrow" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
